function Hauszeitung_list_element(element) {
    this.$element = $(element);
    this.containerId = null;
    this.articleIdDe = null;

    this.selectors = {
      editButtonDe: '.c-hauszeitung-edit-list__edit-button--de',
      editButtonTranslation: '.c-hauszeitung-edit-list__edit-button--translation',
      topArticleButton: '.c-hauszeitung-edit-list__toparticle',
    };

    this.svgs = {
      topArticleYes: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.45 4.73L5.82 21 12 17.27z"/></svg>',
      topArticleNo: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path fill="currentColor" d="M12 15.39l-3.76 2.27.99-4.28-3.32-2.88 4.38-.37L12 6.09l1.71 4.04 4.38.37-3.32 2.88.99 4.28M22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.45 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24z"/></svg>',
    };

    this.init = function() {
      this.containerId = this.$element.attr('data-container-id');
      this.articleIdDe = this.$element.attr('data-article-id-de');
      this.$editButtonDe = this.$element.find(this.selectors.editButtonDe);
      this.$editButtonTranslation = this.$element.find(this.selectors.editButtonTranslation);
      this.$topArticleButton = this.$element.find(this.selectors.topArticleButton);

      this.$editButtonDe.on('click', this.$showEditPopupDe.bind(this));
      this.$editButtonTranslation.on('click', this.$showEditPopupTranslation.bind(this));
      this.$topArticleButton.on('click', this.$toggleTopArticle.bind(this));
    };

    this.$showEditPopupDe = function() {
      const call = {
        article_id: this.articleIdDe,
        call: "edit",
        container_id: this.containerId,
        js: "Hauszeitung"
      };

      i4_Popup.add().set_option({
        ajax_param: JSON.parse(JSON.stringify(call)),
        position: 'cursor',
        loader: true
      }).run();
    };

    this.$showEditPopupTranslation = function(event) {
      const duplicateLanguage = $(event.target).attr('data-duplicate-language');
      const articleIdTranslation = $(event.target).attr('data-article-' + duplicateLanguage + '-fk');

      if (articleIdTranslation === '') {
        // create new translation article
        const call = {
          article_id: this.articleIdDe,
          call: "create_duplicate",
          duplicate_language: duplicateLanguage,
          container_id: this.containerId,
          js: "Hauszeitung"
        };

        i4_Popup.add().set_option({
          ajax_param: JSON.parse(JSON.stringify(call)),
          position: 'cursor',
          loader: true
        }).run();
      } else {
        // edit translation article
        const call = {
          article_id: articleIdTranslation,
          call: "edit",
          container_id: this.containerId,
          js: "Hauszeitung"
        };

        i4_Popup.add().set_option({
          ajax_param: JSON.parse(JSON.stringify(call)),
          position: 'cursor',
          loader: true
        }).run();
      }
    };

    this.$toggleTopArticle = function(event) {
      // console.log('event', event);
      // console.log('this', this);
      const isTopArticle = $(event.currentTarget).hasClass('c-hauszeitung-edit-list__toparticle--yes');
      // console.log('isTopArticle', isTopArticle);
      let param = null;

      if (isTopArticle) {
        param = jQuery.param({
          js: 'Hauszeitung',
          call: 'article_change_toparticle',
          article_id: this.articleIdDe,
          toparticle: 0,
        });
      } else {
        param = jQuery.param({
          js: 'Hauszeitung',
          call: 'article_change_toparticle',
          article_id: this.articleIdDe,
          toparticle: 1,
        });
      }

      i4_Ajax.factory().
        set_parameter(param).
        set_option({
          on_success: ((response) => {
            response = JSON.parse(response);
            // console.log('response', response);
            if (response == 1) {
              // show filled star
              $(event.currentTarget).html(this.svgs.topArticleYes);
              $(event.currentTarget).removeClass('c-hauszeitung-edit-list__toparticle--no');
              $(event.currentTarget).addClass('c-hauszeitung-edit-list__toparticle--yes');
              $(event.currentTarget).closest('.c-hauszeitung-edit-list__article').addClass('c-hauszeitung-edit-list__article--toparticle');
            } else if (response == 0) {
              // show outlined star
              $(event.currentTarget).html(this.svgs.topArticleNo);
              $(event.currentTarget).removeClass('c-hauszeitung-edit-list__toparticle--yes');
              $(event.currentTarget).addClass('c-hauszeitung-edit-list__toparticle--no');
              $(event.currentTarget).closest('.c-hauszeitung-edit-list__article').removeClass('c-hauszeitung-edit-list__article--toparticle');
            } else {
              console.log('%c Top-Artikel speichern fehlgeschlagen ', 'background-color: red; color: white;');
            }
          }).bind(this)
        }).
        run();
    };
}
